import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap'

class MinimizeToggleButton extends Component {
  static propTypes = {
    label: PropTypes.string, // "x"
    className: PropTypes.string, // css classNames to be applied
    handleOnClick: PropTypes.func, // callback function to invoke removing
    level: PropTypes.number, // The level of the current group
    isMinimized: PropTypes.bool
  }

  render() {
    const tooltip = name => <Tooltip id="minimize-toggle-tooltip">{name}</Tooltip>
    return (
      <Button className={`${this.props.className}`} bsSize="xsmall" bsStyle="link" onClick={this.props.handleOnClick}>
        <OverlayTrigger
          placement="top"
          delayShow={1000}
          overlay={this.props.isMinimized ? tooltip('Expand') : tooltip('Collapse')}
        >
          <Glyphicon glyph="chevron-down" />
        </OverlayTrigger>
      </Button>
    )
  }
}

export default MinimizeToggleButton
